import { z } from '@/utils/zod'
import {
    createMultilingualTextSchema,
    StorageResourceSchema,
    ThemeColorsSchema,
    defaultLightThemeColors,
    defaultDarkThemeColors,
} from '@/entities/common'

export const defaultSpaPresenterTheme = {
    favicon: null,
    darkModeEnabled: false,
    schemes: {
        light: {
            colors: { ...defaultLightThemeColors },
            logo: null,
        },
        dark: {
            colors: { ...defaultDarkThemeColors },
            logo: null,
        },
    },
} as const

export const SpaPresenterThemeSchemeSchema = z.object({
    colors: ThemeColorsSchema,
    logo: StorageResourceSchema.nullable(),
})

export const SpaPresenterThemeSchema = z.object({
    favicon: StorageResourceSchema.nullable(),
    darkModeEnabled: z.boolean(),
    schemes: z.object({
        light: SpaPresenterThemeSchemeSchema,
        dark: SpaPresenterThemeSchemeSchema,
    }),
})

export const SpaPresenterDefaultDesignSchema = z.object({
    type: z.literal('default'),
})

export const SpaPresenterCombinedDesignSchema = z.object({
    type: z.literal('combined'),
    startPage: z.object({
        infoTitle: createMultilingualTextSchema(120),
        infoItems: z.array(createMultilingualTextSchema(200)),
    }),
})

export const SpaPresenterSplitDesignSchema = z.object({
    type: z.literal('split'),
    image: StorageResourceSchema.nullable(),
})

export const SpaPresenterDesignSchema = z.discriminatedUnion('type', [
    SpaPresenterDefaultDesignSchema,
    SpaPresenterCombinedDesignSchema,
    SpaPresenterSplitDesignSchema,
])

export const SpaPresenterSchema = z.object({
    type: z.literal('spa'),
    design: SpaPresenterDesignSchema,
    theme: SpaPresenterThemeSchema,
})

export type SpaPresenterDesign = z.infer<typeof SpaPresenterDesignSchema>
export type SpaPresenterThemeScheme = z.infer<typeof SpaPresenterThemeSchemeSchema>
export type SpaPresenterTheme = z.infer<typeof SpaPresenterThemeSchema>
export type SpaPresenter = z.infer<typeof SpaPresenterSchema>
